import React, { useRef, useEffect, useState } from "react";
import "./SkillDescriptionPopup.css";

const PADDING = 8; // px from screen edges

const SkillDescriptionPopup = ({ skill, position, onClose }) => {
    const cardRef = useRef();
    const [adjustedPos, setAdjustedPos] = useState(position);

    useEffect(() => {
        if (!position) return;

        // Defer until popup is in DOM
        requestAnimationFrame(() => {
            const popup = cardRef.current;
            if (!popup) return;

            const { width, height } = popup.getBoundingClientRect();
            let x = position.x ?? window.innerWidth / 2;
            let y = position.y ?? window.innerHeight / 2;

            // Right/bottom edge
            if (x + width + PADDING > window.innerWidth) {
                x = window.innerWidth - width - PADDING;
            }
            // Left edge
            if (x < PADDING) x = PADDING;

            // Bottom edge
            if (y + height + PADDING > window.innerHeight) {
                y = window.innerHeight - height - PADDING;
            }
            // Top edge
            if (y < PADDING) y = PADDING;

            setAdjustedPos({ x, y });
        });
    }, [position, skill]);

    if (!skill) return null;
    return (
        <div className="skill-desc-popup__backdrop" onClick={onClose}>
            <div
                ref={cardRef}
                className="skill-desc-popup__card"
                style={{
                    position: 'fixed',
                    top: adjustedPos?.y ?? '50%',
                    left: adjustedPos?.x ?? '50%',
                    transform: adjustedPos ? 'translate(0,0)' : 'translate(-50%,-50%)',
                    zIndex: 1001,
                }}
                onClick={e => e.stopPropagation()}
            >
                <button className="skill-desc-popup__close" onClick={onClose} aria-label="Close popup">
                    &times;
                </button>
                <div className="skill-desc-popup__name">
                    {skill.name}
                </div>
                <div className="skill-desc-popup__description">
                    {skill.description || <span style={{color:"#aaa"}}>No description available.</span>}
                </div>
                {skill.cost !== undefined && (
                    <div className="skill-desc-popup__cost">
                        Cost: {skill.cost} SP
                    </div>
                )}
            </div>
        </div>
    );
};

export default SkillDescriptionPopup;
